import React, { useState, useEffect } from 'react';
import EditProfile from './EditProfile';
import HeaderNew from '../HeaderNew.js';
import { BreadcrumbBox } from '../common/Breadcrumb.js';
import { useTranslation } from 'react-i18next';

const Profile = (props) => {

    let id = props.match.params.id;

    const { t } = useTranslation();

    return (
    <div className="edit-profile-page">
        <HeaderNew />
        <div style={{ paddingTop: "140px" }}></div>
        <BreadcrumbBox title={t('edit_profile')} />
        <EditProfile id={id} />
    </div>
    );
}

export default  Profile;